import { HostedGamesService } from '@hosted-games/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateHostedGamePlaceholderPlayerDto, UpdatePlaceholderPlayerPathParams } from '@core-http';

export class EditPlayerCommandHandler {
  private readonly hostedGamesService: HostedGamesService = inject(HostedGamesService);

  editPlayer(gameId: string, playerId: string, displayName: string): Observable<void> {
    const pathParams: UpdatePlaceholderPlayerPathParams = { hostedGameId: gameId, gamePlayerId: playerId };
    const payload: CreateHostedGamePlaceholderPlayerDto = { displayName };

    return this.hostedGamesService.editPlayer(pathParams, payload);
  }
}
